<div class="modal-inner" [class.tiny]="data.tiny">
    <h1>{{ data.title ?? 'Toelichting' }}</h1>

    @if (!data.tiny) {
        <mat-form-field class="w-100" appearance="fill">
            <mat-label>Toelichting</mat-label>

            <textarea
                [formControl]="form.controls.comment"
                [placeholder]="data.placeholder ?? 'Toelichting bij urenregistratie'"
                matInput
                rows="8">
            </textarea>

            <mat-error [control]="form.controls.comment"></mat-error>
        </mat-form-field>
    } @else if (data.tiny) {
        <simple-tiny class="w-100 mb-3" [showMenuBar]="false" [content]="form.controls.comment" height="600">
        </simple-tiny>
    }

    <div class="buttons">
        <button
            class="planning-button confirm"
            [disabled]="form.invalid"
            (click)="applyAndClose()"
            mat-raised-button
            color="primary">
            Gereed
        </button>

        <button
            class="planning-button cancel"
            (click)="dialogRef.close()"
            mat-raised-button
            color="basic"
            mat-dialog-close="">
            Annuleren
        </button>
    </div>
</div>
